import { useState } from 'react';
import { FlexContainer, colors, Text } from '@taxdown/piccolo-web';
import { CardClassify } from '@taxdown/kami-sama/dist/kamiSama';
import Trans from 'Components/Trans';
import { CheckIcon } from 'Components/icons';
import TrashIcon from 'Components/icons/TrashIcon';
import SummaryCardBody from '../SummaryCardBody';
import * as Styled from './styles';
import { ClassifyCardProps } from './types';

const ClassifyCard = ({ classifyCard, deleteCard }: ClassifyCardProps): JSX.Element => {
  const [cardRender, setCardRender] = useState(classifyCard?.getRenderForm());
  const { header } = cardRender;
  const [yayoyakis] = useState(classifyCard.getYayoyakis());

  const onDelete = (e: Event): void => {
    e.stopPropagation();
    deleteCard(classifyCard);
    setCardRender(classifyCard?.getRenderForm());
  };

  const onSelect = (card: CardClassify): void => {
    card.setSelected(!card.isSelected());
    setCardRender(card?.getRenderForm());
  };

  return (
    <Styled.Container>
      <Styled.CardContainer isSelected={false}>
        <Styled.Header>
          <Text type="paragraphs" color="dark" size="S_S_M" mr="dimension_10">
            {header}
          </Text>
          {classifyCard.isSelected() ? (
            <Styled.SelectedStatus onClick={() => onSelect(classifyCard)}>
              <FlexContainer>
                <CheckIcon color={colors.green_500} />
              </FlexContainer>
              <Text type="paragraphs" color="success_strong" size="S_M_M">
                <Trans i18nKey="PayersSummary.activityAdded" ns="validations" />
              </Text>
            </Styled.SelectedStatus>
          ) : (
            <Styled.AddButtonStyled
              title="PayersSummary.addActivity"
              onClick={() => onSelect(classifyCard)}
            />
          )}
        </Styled.Header>
        <Styled.Body>
          <SummaryCardBody yayoyakis={yayoyakis} />
        </Styled.Body>
      </Styled.CardContainer>
      <Styled.TrushArea onClick={onDelete} data-testid="deleteButton">
        <TrashIcon />
      </Styled.TrushArea>
    </Styled.Container>
  );
};

export default ClassifyCard;
